import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const PlusIcon = ({
  title = 'Plus',
  viewBox = '0 0 16 16',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M8.07955 0C8.61211 0 9.04743 0.416307 9.07785 0.941242L9.07955 1L9.07933 7.07922L15 7.07955C15.5523 7.07955 16 7.52726 16 8.07955C16 8.61211 15.5837 9.04743 15.0588 9.07785L15 9.07955L9.07933 9.07922L9.07955 15C9.07955 15.5523 8.63183 16 8.07955 16C7.54699 16 7.11166 15.5837 7.08124 15.0588L7.07955 15L7.07933 9.07922L1 9.07955C0.447715 9.07955 0 8.63183 0 8.07955C0 7.54699 0.416307 7.11166 0.941242 7.08124L1 7.07955L7.07933 7.07922L7.07955 1C7.07955 0.447715 7.52726 0 8.07955 0Z" />
  </CreateIconComponent>
);

export default PlusIcon;
